module.exports = __webpack_public_path__ + "img/40.fc98116d.jpg";